import { render } from "./DataTableLayout.vue?vue&type=template&id=134d2b37"
const script = {}

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__